/**
 * IWAO Banner Slideshow
 * Handles fade transitions between slides.
 * Ken Burns animation is handled entirely by CSS.
 */
(function () {
  'use strict';

  function initSlideshow() {
    var container = document.querySelector('.banner__slideshow[data-slide-count]');
    if (!container) return;

    var slides = container.querySelectorAll('.banner__slide');
    if (slides.length < 2) return; // Single slide = Ken Burns only, no cycling

    var duration = (parseInt(container.dataset.slideDuration, 10) || 7) * 1000;
    var current = 0;

    function nextSlide() {
      slides[current].classList.remove('banner__slide--active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('banner__slide--active');
    }

    setInterval(nextSlide, duration);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshow);
  } else {
    initSlideshow();
  }
})();
